<template>
  <div>
    <Counter ref="cnt" v-show="wait" :from="counter" v-on:end="waitEnd" />
     <!-- The video -->
    <Video v-show="run" ref="vid" :src="'http://assets.keepyou.fit/fitness/' + config.group + '/' + config.file" :poster="'http://assets.keepyou.fit/fitness/' + config.group + '/' + config.prev">
      <div class="workout-top-left">
        <p class="is-size-3">{{ config.name }}</p>
        <p class="is-size-4 has-text-grey">{{ $t('O from M', { O: currentWorkout + 1, M: workoutsNumber }) }}</p>
      </div>

      <progress class="progress progress-top is-primary" :value="currentTime + time" :max="workoutLen"></progress>

      <div class="workout-bottom has-text-centered">
        <span v-if="config.repetitions.length > 1" class="is-size-3 p-l-lg" style="float:left">{{ rep + 1 }} / {{ config.repetitions.length }}</span>
        <img @click="end" src="/../../static/svg/arrow-right.svg" class="icon is-medium m-r-md" style="float:right">
        <span @click="playPause" v-show="playing" class="icon has-text-grey is-size-2" style="position: absolute; bottom: 1.25rem;left:50%;margin-left:-0.75rem;">
          <i class="fa fa-pause"></i>
        </span>
        <span @click="playPause" v-show=" ! playing" class="icon has-text-grey is-size-2" style="position: absolute; bottom: 1.25rem;left:50%;margin-left:-0.75rem;">
          <i class="fa fa-play"></i>
        </span>
        <progress @click="playPause" class="progress is-primary" :value="time" :max="repLength">{{ time }} sec</progress>
      </div>

      <div class="workout-top-right">
        <img @click="menu" src="@/../static/svg/cancel.svg" class="is-medium icon" style="opacity:0.5;">
      </div>
    </Video>
  </div>
</template>

<script>
import Video from '@/components/Settings/Video'
import Counter from '@/components/Settings/Counter'

export default {
  name: 'Showcase',
  props: ['config', 'workoutsNumber', 'currentWorkout', 'workoutLen', 'currentTime'],
  data () {
    return {
      run: false,
      wait: false,
      playing: false,
      counter: 3,
      time: 0,
      interval: undefined,
      repLength: 20,
      rep: 0
    }
  },
  mounted () {
    this.wait = true
    this.$refs.cnt.start(3)
  },
  methods: {
    start () {
      this.time = 0
      this.repLength = this.config.repetitions[this.rep]
      this.play()
    },
    play () {
      this.run = true
      this.playing = true
      this.wait = false
      this.$refs.vid.play()
      this.interval = setInterval(this.go, 1000)
    },
    pause () {
      clearInterval(this.interval)
      this.playing = false
      this.$refs.vid.pause()
    },
    playPause () {
      if (this.playing) {
        this.pause()
      } else {
        this.play()
      }
    },
    menu () {
      this.playing = false
      this.$refs.vid.pause()
      clearInterval(this.interval)
      this.$emit('menu')
    },
    skipWait () {
      this.run = false
      this.$refs.vid.pause()
    },
    waitEnd () {
      this.start()
    },
    end () {
      this.rep = 0
      this.run = false
      this.wait = false
      this.$refs.vid.stop()
      this.$emit('end')
    },
    go() {
      this.time++
      if (this.time >= this.repLength) {
        this.repEnd()
      }
    },
    repEnd() {
      clearInterval(this.interval)
      this.run = false
      this.wait = true
      this.$refs.vid.stop()
      this.rep++
      if (this.rep >= this.config.repetitions.length) {
        this.end()
      } else {
        this.$refs.cnt.start(this.config.break)
      }
    }
  },
  components: {
    Video,
    Counter
  }
}
</script>

<style>
.workout-top-left {
  position: fixed;
  top: 1rem;
  left: 1rem;
}
.workout-top-right {
  position: fixed;
  top: 1rem;
  right: 1rem;
}
.workout-bottom {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
}
.workout-mitte {
  position: fixed;
  top: 50%;
  left: 50%;
  margin-left: -2rem;
  margin-top: -2rem;
  width: 4rem;
}
.workout-bottom .progress {
  border-radius: 0;
  height: 4rem;
  opacity: 0.5;
}
.progress-top {
  position: fixed;
  top:0;
  left:0;
  width: 100%;
  opacity: 0.5;
  border-radius: 0;
  background:transparent;
  border:none
}
</style>


// WEBPACK FOOTER //
// src/components/Settings/Workout.vue